import { render, staticRenderFns } from "./editDebtCategoryModalContent.vue?vue&type=template&id=6a6dc88b&scoped=true"
import script from "./editDebtCategoryModalContent.vue?vue&type=script&lang=js"
export * from "./editDebtCategoryModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6dc88b",
  null
  
)

export default component.exports